import type { Entity } from './Entity.js';

/**
 * Component constructor type.
 */
export interface IComponent {
    new (...args: Array<any>): Component
}

/**
 * Base class for ECS components.
 */
export class Component {
    // name of functions an entity gets by applying the component.
    public componentMethods: Array<string> = [];
    public name: string | number;
    public setAttribute: Function = () => {};
    public setAttributeGetter: Function = () => {};
    public removeAttribute: Function = () => {};
    public entityId: string | number;
    public entity : Entity;
    public $api: Record<string, any>;
    public $gameData : any;
    public dependencies?: {[key: string]: IComponent}
    // NonNullable: `dependencies` is optional, so under a consumer's `strict`
    // the bare `this['dependencies'][K]` includes `undefined` and is not a
    // constructor — the published declaration failed to type-check.
    public $deps: {
        [K in keyof NonNullable<this['dependencies']>]: InstanceType<NonNullable<this['dependencies']>[K]>;
    };
    constructor(name: string | number) {
        if (typeof(name) === 'undefined')
        {
            throw "Component: Invalid component name";
        }
        let parentObj = this.constructor.prototype;
        this.componentMethods = Object.getOwnPropertyNames(parentObj).filter(p => {
            return p !== "constructor" && p !== "prototype" && p !== 'onAdded' && p !== 'onRemoved'
        });
        this.name = name;
    }
    // overrided by Entity
    public emit(event: string, payload?: any) {};
    public onAdded(entity: Entity) {};
    public onRemoved(entity: Entity, options?: any) {};
};